import WTPlanIds from '../../../helper-functions/companies/worldtrips-planids';
import {
    isInPlanList,
    onlyAlphaNumeric
} from '../../../helper-functions/helper-functions';

const wtPlanIds = new WTPlanIds();

// Centralize the WorldTrips plan groups and their related rules.
const hccConfig = {
    planId: ibJS.planId || ibJS.application.planId,
    exchangeGuardPlans: [
        wtPlanIds.ExchangeGuard_Choice,
        wtPlanIds.ExchangeGuard_Essential
    ],
    exchangeGuardGrpPlans: [
        wtPlanIds.ExchangeGuard_Group_Choice,
        wtPlanIds.ExchangeGuard_Group_Essential
    ],
    allExchangeGuardPlans: [
        wtPlanIds.ExchangeGuard_Choice,
        wtPlanIds.ExchangeGuard_Essential,
        wtPlanIds.ExchangeGuard_Group_Choice,
        wtPlanIds.ExchangeGuard_Group_Essential
    ],
    studentSecurePlans: [
        wtPlanIds.StudentSecure_Elite,
        wtPlanIds.StudentSecure_Select,
        wtPlanIds.StudentSecure_Budget,
        wtPlanIds.StudentSecure_Smart
    ],
    internationalPlans: [
        wtPlanIds.Atlas_International,
        wtPlanIds.Atlas_Premium_International,
        wtPlanIds.Atlas_Essential_International
    ],
    isExchangeGuard: function() {
        return isInPlanList(this.exchangeGuardPlans, this.planId);
    },
    isExchangeGuardGrp: function() {
        return isInPlanList(this.exchangeGuardGrpPlans, this.planId);
    },
    allExchangeGuard: function() {
        return isInPlanList(this.allExchangeGuardPlans, this.planId);
    },
    isStudentSecure: function() {
        return isInPlanList(this.studentSecurePlans, this.planId);
    },
    isInternationalPlans: function() {
        return isInPlanList(this.internationalPlans, this.planId);
    }
};

function requiredIfStudentPlans(x) {
    if (hccConfig.isStudentSecure() && typeof x !== 'boolean') {
        return !(x === '' || !x);
    }
    return true;
}

function requiredIfExchangePlans(x) {
    if (hccConfig.isExchangeGuard() && typeof x !== 'boolean') {
        return !(x === '' || !x);
    }
    return true;
}

function alphaNumericIfStudentPlans(x) {
    if (hccConfig.isStudentSecure() && typeof x !== 'boolean') {
        return onlyAlphaNumeric(x);
    }
    return true;
}

function alphaNumericIfExchangePlans(x) {
    if (hccConfig.isExchangeGuard() && typeof x !== 'boolean') {
        return onlyAlphaNumeric(x);
    }
    return true;
}

function requiredIfStudentPlansAndUSA(x) {
    // INSUBUY-4596 Make the changes to treat American Samoa, Guam, Northern Mariana Islands as any other non-US territory
    const dest = this.destinationCountry || this.application?.destinationCountries?.[0]?.country;
    if (!dest) return true;
    return !(!requiredIfStudentPlans(x) && ['PRI', 'USA', 'UMI', 'VIR', 'PLW', 'MHL'].indexOf(dest) > -1);
}

// SUPDT-1893: only these EEA countries continue to show the physically located
// attestation.
const attestationEeaCountries = ['FRA', 'DEU', 'ITA', 'ESP'];
const homeCountryQus = ['GBR', 'AUS', 'CAN'];
const getRestrictedHomeCountries = () => [
    ...homeCountryQus,
    ...attestationEeaCountries
];

const selectedWorldTripPlans = [
    wtPlanIds.Atlas_America,
    wtPlanIds.VisitorSecure_Parent,
    wtPlanIds.Atlas_Essential_America,
    wtPlanIds.Atlas_Premium_America,
    wtPlanIds.ExchangeGuard_Choice,
    wtPlanIds.ExchangeGuard_Essential,
    wtPlanIds.Atlas_MedEvac,
    wtPlanIds.ExchangeGuard_Group_Choice,
    wtPlanIds.ExchangeGuard_Group_Essential
];

export {
    WTPlanIds,
    alphaNumericIfExchangePlans,
    alphaNumericIfStudentPlans,
    attestationEeaCountries,
    getRestrictedHomeCountries,
    hccConfig,
    requiredIfExchangePlans,
    requiredIfStudentPlans,
    requiredIfStudentPlansAndUSA,
    selectedWorldTripPlans,
    wtPlanIds
};
